// import AboutUsSection from "../Component/LandingV2/AboutUsSection";
import ConfidenceSection from "../Component/LandingV2/ConfidenceSection";
import FeatureSection from "../Component/LandingV2/FeatureSection";
import MobileAppSection from "../Component/LandingV2/MobileAppSection";
import ToolkitSection from "../Component/LandingV2/ToolkitSection";
import AskAnythingSection from "../Component/LandingV2/AskAnythingSection";
import OurClientsSection from "../Component/LandingV2/OurClientsSection";
import PartnerSection from "../Component/LandingV2/PartnerSection";
import FaqSection from "../Component/LandingV2/FaqSection";
import Footer from "../Component/LandingV2/Footer";
import HomeSection from "../Component/LandingV2/HomeSection";
// import NLPSection from "../Component/LandingV2/NLPSection";
import Navbar from "../Component/LandingV2/Navbar";
// import NewsletterSection from "../Component/LandingV2/NewsletterSection";
// import SignupSection from "../Component/LandingV2/SignupSection";
import NewsHubSection from "../Component/LandingV2/NewsHubSection";
import "./LandingV2.scss";
import MarketSubscribeSection from "../Component/LandingV2/MarketSubscribeSection";
import SecondWireframeSection from "../Component/LandingV2/SecondWireframeSection";

const LandingV2 = () => {
  return (
    <div className="landing-v2">
      <Navbar />
      {/* Home Section */}
      <HomeSection />
      <SecondWireframeSection />
      <ConfidenceSection />
      <FeatureSection />
      <MobileAppSection />
      <ToolkitSection />
      <AskAnythingSection />
      <OurClientsSection />
      <PartnerSection />
      <FaqSection />
      {/* <NLPSection /> */}
      {/* <NewsletterSection /> */}
      {/* <SignupSection /> */}
      {/* <AboutUsSection /> */}
      {/* <NewsHubSection /> */}
      {/* <MarketSubscribeSection /> */}
      <Footer />
    </div>
  );
};

export default LandingV2;
